import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import Modal from './Modal.js';

class Categorias extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
                {
                    Header: "Pertenece A",
                    id: "Padre",
                    accessor: d => d.Padre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                     {
                         create: true,
                         component: (props) => <Modal {...props} action="CREATE" />,
                         permission: 'ecommerce_articulos_categorias_new',
                     },
                     {
                         edit: true,
                         component: (props) => <Modal {...props} action="EDIT" />,
                         permission: 'ecommerce_articulos_categorias_edit',
                     },
                     {
                         detail: true,
                         component: (props) => <Modal {...props} action="DETAIL" />,
                         permission: 'ecommerce_articulos_categorias_detail',
                     },
                     {
                         delete: true,
                         component: (props) => <Modal {...props} action="DELETE" />,
                         permission: 'ecommerce_articulos_categorias_delete',
                     }
                ]}
                apiUrl={api.gestion.articulos.categorias}
                columns={this.state.columns}
                title={"Categorias"}
            />
        );
    }
}

export default Categorias;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Categorias/Categorias.js